export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = await getCurrentUser()

  if (!user && to.path !== '/users/login')
    return navigateTo('/users/login')

  if (to.meta.designerOnly && import.meta.server) {
    const isAdmin = await getAdmin(user)

    if (!isAdmin)
      return navigateTo('/')
  }
})
